module.exports = __webpack_public_path__ + "img/Photo_8__Construction_985_109_49.c9300405.jpg";